<template>
<div id="listen" >
    <div v-if="unit != null" id="unit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="ebookHeader">
            <div style="margin-top:10px;"><a href="#" @click="backToIndex" class="backBtn backBtn-eBook">Back</a></div>
        </div>
        <el-card shadow="hover"  v-for="(listen,index) of listens" :key="index" style="width: 80%;margin: auto auto;">
            <div>
                <el-row style="text-align: center; padding: 5px;">
                    <el-col :span="4">Part {{listen.idx}}</el-col>
                    <audio :span="16" :src="listen.url" controls />
                </el-row>
            </div>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    name : 'ListenAudio',
    data(){
        return {
            listens : [],
            fullscreenLoading : false,
            unit : null
        }
    },
    methods : {
        backToIndex : function(){
            this.$router.go(-1);
        },
    },
    mounted : function(){
        let _this = this;
        if(_this.$route.params.unit){
            _this.unit = _this.$route.params.unit;
            localStorage.setItem("unit",JSON.stringify(_this.unit));
        }else{
            if(localStorage.getItem("unit")){
                _this.unit = JSON.parse(localStorage.getItem("unit"));
            }else{
                _this.$router.go(-1);
            }
        }
        _this.request("GET","/listens/list/"+_this.unit.id, null, function(data){
            _this.listens = data;
            if(_this.listens.length == 0){
                _this.$alert('未上传音频，请联系管理员', '', {
                    confirmButtonText: '确定',
                    callback: action => {
                        _this.$router.go(-1);
                    }
                });
            }
        })

    },
}
</script>

<style>
div img:hover{  
    transform: scale(1.05);  
} 
</style>